<template>
  <v-container fluid>
    <material-card
      icon="mdi-clipboard-text"
      inline
      title="Schedule Teacher Training"
    >
      <v-row>
        <v-col cols="12" lg="3">
          <label for="type">Training Type *</label>
          <v-radio-group
            class="radio-type"
            id="type"
            v-model="formData.type"
            row
          >
            <v-radio
              color="deep-purple accent-4"
              label="Online"
              value="online"
            ></v-radio>
            <v-radio
              color="deep-purple accent-4"
              label="Offline"
              value="offline"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" lg="3" v-if="formData.type === 'online'">
          <v-checkbox
            hide-details
            class="my-0 py-1"
            v-model="formData.selfInvitation"
            label="Self Invited"
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-card-actions>
        <a @click="$router.back()">
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            elevation="1"
            absolute
            right
            top
          >
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn
            v-else
            fixed
            right
            fab
            small
            color="grey lighten-2"
            elevation="1"
            class="mr-n2 mt-10"
            style="opacity: 0.6"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>
        <form autocomplete="off" @submit.prevent="onSave">
          <v-row>
            <v-col cols="3" lg="3">
              <span
                v-if="formData.type === 'online'"
                inline
                title="New Online Training"
                icon="mdi-clipboard-text"
                >New Online Training</span
              >
              <span
                v-else
                inline
                title="New Offline Training"
                icon="mdi-clipboard-text"
                >New Offline Training</span
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" lg="4">
              <label for="type">Training Title * </label>
              <v-text-field
                required
                id="type"
                color="deep-purple accent-4"
                v-model="formData.title"
                placeholder="Title"
              >
              </v-text-field>
            </v-col>

            <v-col cols="4" lg="4">
              <label> From Date * </label>
              <custom-date-picker
                required
                color="deep-purple accent-4"
                v-model="formData.fromDate"
                @input="fromDateChange()"
                :minToDate="currentDate"
              />
            </v-col>
            <v-col cols="4" lg="4">
              <label> To Date * </label>
              <custom-date-picker
                color="deep-purple accent-4"
                v-model="formData.toDate"
                :minToDate="formData.fromDate"
              />
            </v-col>
            <v-col cols="4" lg="4">
              <label> From Time * </label>
              <v-menu
                ref="menu1"
                v-model="menu2"
                :close-on-content-click="false"
                color="deep-purple accent-4"
                :nudge-right="40"
                :return-value.sync="formData.fromTime"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    required
                    color="deep-purple accent-4"
                    v-model="formData.fromTime"
                    aria-required="true"
                    label="--Select Time--"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                  </v-text-field>
                </template>
                <v-time-picker
                  required
                  color="deep-purple accent-4"
                  v-if="menu2"
                  v-model="formData.fromTime"
                  full-width
                  format="24hr"
                  @click:minute="$refs.menu1.save(formData.fromTime)"
                ></v-time-picker>
              </v-menu>
            </v-col>

            <v-col cols="4" lg="4">
              <label> To Time * </label>
              <v-menu
                ref="menu2"
                v-model="menu3"
                color="deep-purple accent-4"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="formData.toTime"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    color="deep-purple accent-4"
                    v-model="formData.toTime"
                    aria-required="true"
                    label="--Select Time--"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                  </v-text-field>
                </template>
                <v-time-picker
                  color="deep-purple accent-4"
                  v-if="menu3"
                  v-model="formData.toTime"
                  full-width
                  format="24hr"
                  @click:minute="$refs.menu2.save(formData.toTime)"
                >
                </v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="select">Select Zone *</label>
              <v-autocomplete
                v-model="formData.zone"
                multiple
                id="select"
                class="my-0 py-1"
                placeholder="--Select--"
                name="sZone"
                :items="selectedZones"
                item-text="zone"
                item-value="zone"
                key="id"
                @input="onZoneSelect()"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectS">Select States *</label>
              <v-autocomplete
                v-model="formData.state"
                id="selectS"
                class="my-0 py-1"
                placeholder="--Select--"
                name="sCity"
                :items="selectedState"
                item-text="state"
                item-value="state"
                key="id"
                multiple
                @input="onStateSelect()"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectC">Select Cities *</label>
              <v-autocomplete
                v-model="formData.city"
                id="selectC"
                class="my-0 py-1"
                placeholder="--Select--"
                name="sCity"
                :items="selectedCity"
                item-text="city"
                item-value="city"
                key="id"
                multiple
                @input="onCitySelect()"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectCe">Centers eligible for training *</label>
              <v-autocomplete
                v-model="formData.franchiseeIds"
                id="selectCe"
                class="my-0 py-1"
                placeholder="--Select--"
                name="sCenter"
                :items="selectedCenter"
                item-text="companyName"
                item-value="id"
                key="id"
                multiple
                @input="onCenterSelect()"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectCl">Select Class Group *</label>
              <v-autocomplete
                id="selectCl"
                v-model="formData.classGroupIDs"
                class="my-0 py-1"
                placeholder="--Select--"
                name="sClass"
                :items="classData"
                item-text="name"
                item-value="id"
                key="id"
                multiple
              >
              </v-autocomplete>
            </v-col>
            <!-- over here -->
            <v-col cols="4" lg="4" v-show="formData.type === 'offline'">
              <label for="selectClo">Training Location *</label>
              <v-autocomplete
                id="selectClo"
                class="my-0 py-1"
                placeholder="--Select--"
                name="sLocation"
                :items="selectedLocation"
                item-text="companyName"
                item-value="id"
                key="id"
                v-model="formData.locationCenterID"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectT">Select Trainers *</label>
              <v-autocomplete
                id="selectT"
                v-model="formData.trainerIds"
                class="my-0 py-1"
                placeholder="--Select--"
                name="sTrainer"
                :items="selectedTrainer"
                item-text="firstName"
                item-value="id"
                key="id"
                multiple
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectB">Batch Size *</label>
              <v-text-field
                id="selectB"
                class="my-0 py-1"
                placeholder="--Select--"
                name="sBatch"
                required
                v-model="formData.batchSize"
                key="id"
                maxLenth="100"
                :max="100"
                :min="1"
                type="number"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectStaff">Staff List </label>
              <multiselect
                id="selectStaff"
                placeholder="--Select--"
                class="overflowmultiselect2"
                label="fullName"
                track-by="id"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :preselect-first="false"
                :multiple="true"
                :options="teachersData"
                v-model="formData.staffIds"
              ></multiselect>
            </v-col>
            <!-- <v-col cols="4" lg="4">
              <label>
                Registration End Date
              </label>
              <custom-date-picker color="deep-purple accent-4"
                v-model="formData.registrationEndDate" :maxToDate="yesterday" />
            </v-col> -->
          </v-row>
          <div class="text-right">
            <button
              type="button"
              class="button is-danger"
              @click="$router.push({ name: 'AllTrainings' })"
            >
              Cancel
            </button>
            <button class="button is-success ms-2" type="submit">Save</button>
          </div>
        </form>
      </v-card-component>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import VCardComponent from '../template/VCardComponent.vue'
import MaterialCard from '@/components/template/MaterialCard'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import moment from 'moment'
import { mapGetters } from 'vuex'
import constants from '@/utils/constants'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'

export default {
  name: 'NewTraining',

  components: {
    VCardComponent,
    MaterialCard,
    CustomDatePicker,
    Multiselect
  },

  data: function () {
    return {
      formData: {
        title: '',
        type: 'offline',
        selfInvitation: false,
        fromDate: '',
        toDate: '',
        fromTime: '',
        toTime: '',
        state: [],
        zone: '',
        city: [],
        franchiseeIds: [],
        classGroupIDs: [],
        trainerIds: [],
        locationCenterID: '',
        batchSize: '',
        registrationEndDate: '',
        staffIds: []
      },
      currentDate: moment().format('YYYY-MM-DD'),
      selectedZones: [],
      selectedCity: [],
      selectedState: [],
      selectedCenter: [],
      selectedClass: [],
      selectedTrainer: [],
      selectedBatch: '',
      selectedLocation: [],
      maxToDate: moment().format('YYYY-MM-DD'),
      disabled: false,
      menu2: false,
      menu3: false,
      classData: [],
      isLoading: false,
      franchiseeData: [],
      selectedStates: [],
      yesterday: '',
      teachersData: [],
      franchiseeIDs: [],
      selectedStaff: []
    }
  },
  mounted: async function () {},

  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },

  async created () {
    try {
      await this.getZoneDetails()
      await this.getAllTrainerList()
    } catch (e) {
      console.log(e)
    }
  },

  methods: {
    async onSave () {
      try {
        if (this.validateForm()) {
          if (this.formData.staffIds.length > this.formData.batchSize) {
            this.errMsg('Staff count exceeds the batch size!')
          } else {
            let franchiseeId = []
            this.formData.franchiseeIds.map((obj) => {
              let searchIndex = this.selectedCenter
                .map((a) => a.id)
                .indexOf(obj)
              franchiseeId.push({
                id: obj,
                name: this.selectedCenter[searchIndex].companyName
              })
            })
            console.log('formdata franchiid: ', this.formData.franchiseeIds)
            console.log('formdata traineid:', this.formData.trainerIds)

            let trainerId = []
            this.formData.trainerIds.map((obj) => {
              let searchIndex = this.selectedTrainer
                .map((a) => a.id)
                .indexOf(obj)
              trainerId.push({
                id: obj,
                name: this.selectedTrainer[searchIndex].firstName
              })
            })

            let staffids = []
            this.formData.staffIds.map((obj) => {
              staffids.push({
                id: obj.id,
                franchiseeID: obj.franchiseeID
              })
            })

            await http.post(
              `${constants.API_URL}/api/teacher-training/create-training`,
              Object.assign(
                this.formData,
                {
                  franchiseeIds: franchiseeId
                },
                {
                  trainerIds: trainerId
                },
                {
                  staffIds: staffids
                }
              )
            )

            this.$buefy.dialog.confirm({
              type: 'is-success',
              title: 'Success',
              hasIcon: true,
              message: 'Training created successfully.',
              canCancel: [false, false, false],
              onConfirm: () => {
                this.$router.push({ name: 'TeacherLedTraining' })
              }
            })
          }
        } else {
          this.errMsg('Please fill all the required fields!')
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    validateForm () {
      for (let key of Object.keys(this.formData)) {
        let exclude = []
        if (this.formData.type === 'online') {
          exclude.push('locationCenterID')
        }
        let type = typeof this.formData[key]
        if (exclude.indexOf(key) === -1) {
          if (type === 'string') {
            if (!this.formData[key]) {
              return false
            }
          } else {
            if (this.formData[key].length === 0) {
              return false
            }
          }
        }
      }
      return true
    },
    onZoneSelect () {
      this.getStateDetails()
    },

    onStateSelect () {
      this.getCityDetails()
    },

    onCitySelect () {
      this.getCenterDetails()
    },
    onCenterSelect () {
      this.getClassData()
      this.getApprovedStaffList()
    },

    onClassSelect () {
      this.getAllTrainerList()
    },

    fromDateChange () {
      this.yesterday = moment(this.formData.fromDate)
        .add(-1, 'days')
        .format('YYYY-MM-DD')
        .toString()
      this.formData.registrationEndDate = this.yesterday
      if (moment(this.formData.fromDate).isAfter(this.formData.toDate)) {
        this.formData.toDate = this.formData.fromDate
      }
    },

    clearDetails () {
      let ref = this
      ref.$dialog.warning({
        title: 'Cancel Training',
        text: 'Do you really want to <b>Cancel</b> this training?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'red',
            text: 'Yes',
            handle: async () => {
              this.formData.title = ''
              this.formData.fromDate = ''
              this.formData.toDate = ''
              this.formData.fromTime = ''
              this.formData.toTime = ''
              this.formData.zones = ''
              this.formData.state = ''
              this.formData.city = ''
              this.formData.centers = ''
              this.formData.class = ''
              this.formData.location = ''
              this.formData.trainer = ''
              this.formData.batch = ''
              this.formData.rDate = ''
            }
          }
        }
      })
    },
    getZoneDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(
          `${constants.API_URL}/api/teacher-training/zone-options`
        )

        this.selectedZones = result.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },

    getStateDetails: async function () {
      try {
        this.isLoading = true
        let zone = this.formData.zone
        this.selectedState = []

        let res = await http.post(
          `${constants.API_URL}/api/teacher-training/state-options`,
          { zone }
        )

        this.selectedState = res.data
        this.isLoading = false
      } catch (e) {
      } finally {
        this.formData.state = _.intersection(
          _.map(this.selectedState, (a) => a.state),
          this.formData.state
        )
        this.getCityDetails()
      }
    },

    getCityDetails: async function () {
      try {
        this.isLoading = true
        this.selectedCity = []
        let states = []
        states = this.formData.state
        let res = await http.post(
          `${constants.API_URL}/api/teacher-training/city-options`,
          { states }
        )
        this.selectedCity = res.data
        this.isLoading = false
      } catch (e) {
      } finally {
        this.formData.city = _.intersection(
          _.map(this.selectedCity, (a) => a.city),
          this.formData.city
        )
        this.getCenterDetails()
      }
    },

    getCenterDetails: async function () {
      try {
        this.isLoading = true
        this.selectedCenter = []
        this.selectedLocation = []
        let cities = []
        cities = this.formData.city
        let res = await http.post(
          `${constants.API_URL}/api/teacher-training/franchisee-options`,
          { cities }
        )
        this.selectedCenter = res.data
        this.selectedLocation = this.selectedCenter
        this.isLoading = false
      } catch (e) {
      } finally {
        this.formData.franchiseeIds = _.intersection(
          _.map(this.selectedCenter, (a) => a.id),
          this.formData.franchiseeIds
        )
        let intersect = _.map(this.selectedLocation, (a) => a.id).indexOf(
          this.formData.locationCenterID
        )
        if (intersect === -1) {
          this.formData.locationCenterID = ''
        }
      }
    },
    getClassData: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(
          `${constants.API_URL}/api/student/getclass-group`
        )
        this.isLoading = false
        data = _.filter(data, (e) => {
          return (
            e.type === constants.ClassGroupTypes.teacherTraining &&
            e.isActive === true
          )
        })
        this.classData = data
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },

    getAllTrainerList: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(
          `${constants.API_URL}/api/teacher-training/trainer-options`
        )
        this.isLoading = false

        this.selectedTrainer = data
        //  data = _.filter(data, (e) => {
        //   return e.type === constants.ClassGroupTypes.teacherTraining && e.isActive === true
        // })
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getApprovedStaffList: async function () {
      this.franchiseeIDs = this.formData.franchiseeIds
      try {
        const { data } = await http.post(
          `${constants.API_URL}/api/teacher-training/get-staff?franchiseeID=${this.franchiseeIDs}&&isTeachingStaff=true`
        )
        _.map(data, (d) => {
          d.user.fullName = `${d.user.firstName} ${d.user.lastName} (${d.franchisee.companyName})`
          d.user.franchiseeID = d.franchisee.id
          this.teachersData.push(d.user)
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.overflowmultiselect2 >>> .multiselect__tags {
  border: none;
  border-bottom: solid 0.5px gray;
  border-radius: none;
}
</style>
